import { API2_HOST } from '../../helpers/urlHelper';
import {
  baseGetWithoutParam,
  baseSearch
} from 'services/base-services/baseService';

const baseURL = `${API2_HOST}/sp-new-bus-analysis`;
const search = async request => {
  return await baseSearch(baseURL, request);
};

const getMonthlyFrames = async (id, year) => {
  return await baseGetWithoutParam(
    baseURL + '/monthly?userId=' + id + '&year=' + year
  );
};

const getQuarterlyFrames = async (id, year) => {
  return await baseGetWithoutParam(
    baseURL + '/quarterly?userId=' + id + '&year=' + year
  );
};

const getAccountManagers = async () => {
  return await baseGetWithoutParam(baseURL + '/account-managers');
};

export { search, getMonthlyFrames, getQuarterlyFrames, getAccountManagers };
